﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailAktionEntsorgerMenge extends GuiDetailGeneric {

    constructor() {
        super("GuiDetailAktionEntsorgerMenge");
    }

    protected validateClient() {
        this.log("validateClient");

        const ausgefuehrtAm = $("#VmDetail_AusgefuehrtAm").val() as string;

        this.log(`ausgefuehrtAm=[${ausgefuehrtAm}]`);

        const d = new Date(ausgefuehrtAm);

        const today = new Date();
        today.setHours(23, 59, 59, 0);

        this.log(`d <= today=[${d > today}]`);
        if (d <= today) {
            return true;
        }
        this.createToastValidate("Validierung", "Bitte Ausführungsdatum angeben. Kleiner oder gleich heute.", "warning", 5000);

        return false;
    }
}
